import { PersonalizationPayload } from './types';

const PERSONALIZATION_KEYWORDS: Record<string, keyof PersonalizationPayload> = {
  'my table': 'tableAssignment',
  'my seat': 'tableAssignment',
  'table assignment': 'tableAssignment',
  'where am i sitting': 'tableAssignment',
  'my ticket': 'ticketTier',
  'ticket tier': 'ticketTier',
  'my tier': 'ticketTier',
  'my meal': 'mealSelection',
  'meal selection': 'mealSelection',
  'my food': 'mealSelection',
  'what am i eating': 'mealSelection',
};

export function matchPersonalization(
  question: string,
  personalization: PersonalizationPayload,
): string | null {
  const normalized = question.toLowerCase();

  for (const [keyword, field] of Object.entries(PERSONALIZATION_KEYWORDS)) {
    if (normalized.includes(keyword)) {
      const value = personalization[field];
      if (value === null) {
        return `Your ${formatFieldName(field)} information is not yet available. Please check with an organizer.`;
      }
      return formatPersonalizationResponse(field, value);
    }
  }

  return null;
}

function formatFieldName(field: keyof PersonalizationPayload): string {
  switch (field) {
    case 'tableAssignment':
      return 'table assignment';
    case 'ticketTier':
      return 'ticket tier';
    case 'mealSelection':
      return 'meal selection';
  }
}

function formatPersonalizationResponse(field: keyof PersonalizationPayload, value: string): string {
  switch (field) {
    case 'tableAssignment':
      return `Your table assignment is: ${value}`;
    case 'ticketTier':
      return `Your ticket tier is: ${value}`;
    case 'mealSelection':
      return `Your meal selection is: ${value}`;
  }
}
